/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { Attempt } from './Attempt';
import {
  AttemptFromJSON,
  AttemptFromJSONTyped,
  AttemptToJSON,
} from './Attempt';

/**
 * Each rule keeps an ordered dictionary of attempts where the key is the ModelKey
 * @export
 * @interface RuleHistory
 */
export interface RuleHistory {
  /**
   * Ordered dict of Call.id or Sms.id to Attempt state
   * @type {{ [key: string]: Attempt; }}
   * @memberof RuleHistory
   */
  attempts?: { [key: string]: Attempt };
  /**
   * For history legibility, mark each rule history with the rule type
   * @type {string}
   * @memberof RuleHistory
   */
  ruleType?: RuleHistoryRuleTypeEnum;
}

/**
 * @export
 */
export const RuleHistoryRuleTypeEnum = {
  Call: 'call',
  Sms: 'sms',
} as const;
export type RuleHistoryRuleTypeEnum =
  (typeof RuleHistoryRuleTypeEnum)[keyof typeof RuleHistoryRuleTypeEnum];

/**
 * Check if a given object implements the RuleHistory interface.
 */
export function instanceOfRuleHistory(value: object): value is RuleHistory {
  return true;
}

export function RuleHistoryFromJSON(json: any): RuleHistory {
  return RuleHistoryFromJSONTyped(json, false);
}

export function RuleHistoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RuleHistory {
  if (json == null) {
    return json;
  }
  return {
    attempts:
      json['attempts'] == null
        ? undefined
        : mapValues(json['attempts'], AttemptFromJSON),
    ruleType: json['rule_type'] == null ? undefined : json['rule_type'],
  };
}

export function RuleHistoryToJSON(value?: RuleHistory | null): any {
  if (value == null) {
    return value;
  }
  return {
    attempts:
      value['attempts'] == null
        ? undefined
        : mapValues(value['attempts'], AttemptToJSON),
    rule_type: value['ruleType'],
  };
}
